import { Box, Header, Text } from '@fhs-legacy/universal-components';
import Picture from 'components/picture';

export const EmptyStateContainer = Box.withConfig({
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  maxWidth: '328px',
  width: 'full',
  marginX: 'auto',
});

export const EmptyStateImage = Picture.withConfig({
  height: '107px',
  width: '95px',
});

export const EmptyStateTitle = Header.withConfig({
  accessibilityLevel: 3,
  marginTop: '$2',
  marginBottom: '$3',
  textTransform: 'capitalize',
  color: 'black',
  fontSize: 'lg',
  textAlign: 'center',
});

export const EmptyStateBody = Text.withConfig({
  textAlign: 'center',
  marginBottom: '$4',
  fontSize: 'sm',
});
